import React from 'react';
import { StarIcon } from 'lucide-react';
const TestimonialsSection = () => {
  const testimonials = [{
    quote: "After 20 years in investment banking, I thought chronic fatigue was just part of the job. NightPhase changed that completely. I'm making better decisions faster, and my team has noticed the difference.",
    name: 'Michael R.',
    title: 'Managing Director, Global Investment Firm',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
  }, {
    quote: "As a tech CEO, my mind used to race all night with product ideas and market concerns. NightPhase helps me shut down at night and power up in the morning. It's become my secret competitive advantage.",
    name: 'David L.',
    title: 'Founder & CEO, Enterprise Software Company',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
  }, {
    quote: 'The difference in my performance after using NightPhase for just two weeks was remarkable. My cognitive endurance has improved, and I no longer hit that 15:00 wall where my decision-making used to falter.',
    name: 'Jonathan T.',
    title: 'Senior Partner, Management Consulting',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
  }];
  return <section className="py-16 md:py-24 bg-gray-50" data-id="element-268">
      <div className="container mx-auto px-4" data-id="element-269">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8" data-id="element-270">
          Executive Testimonials
        </h2>
        <p className="text-lg md:text-xl text-gray-700 text-center max-w-3xl mx-auto mb-16" data-id="element-271">
          Hear from high-performing professionals who've transformed their sleep
          and performance with NightPhase.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-272">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-lg border border-gray-100" data-id="element-273">
              <div className="flex mb-4" data-id="element-274">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-500 fill-current" data-id="element-275" />)}
              </div>
              <p className="text-gray-700 mb-8 italic text-lg" data-id="element-276">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-277">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full mr-4 object-cover" data-id="element-278" />
                <div data-id="element-279">
                  <p className="font-semibold" data-id="element-280">{testimonial.name}</p>
                  <p className="text-sm text-gray-600" data-id="element-281">{testimonial.title}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;